import script from "./WarehouseRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehouseRequests.vue?vue&type=script&setup=true&lang=js"

import "./WarehouseRequests.vue?vue&type=style&index=0&id=3be3310c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be3310c"]])

export default __exports__